export default "__VITE_ASSET__0e4f7b65__"